import "./landing.scss";

require.context("./images", true);
